<button
  *ngIf="blDetails.operation_type !== 'IMPORTACION'"
  (click)="toggleOverlay()"
>
  Registro previo de toma de muestra
</button>

<!-- Overlay Table -->
<div class="overlay-detalle" *ngIf="overlay">
  <div class="detalle-salida">
    <div class="table-header">
      <h2 class="title">
        <span (click)="toggleOverlay()">
          <app-arrow-back></app-arrow-back>
        </span>
        Lista de tomas de muestra
      </h2>
      <div class="container-buttons">
        <button
          (click)="toggleOverlayForm(action.Create)"
        >
          Agregar
        </button>
      </div>
    </div>
    <app-table
      [table_config]="table_config"
      [array]="samplingRecords"
      [loader]="loaderTable"
      (onEliminarEntryExport)="deleteConfirm($event)"
      (onDetalleEntryExport)="toggleOverlayForm(action.Detail, $event)"
      (onActualizarEntryExport)="toggleOverlayForm(action.Update, $event)"
    ></app-table>
  </div>
</div>

<!-- Overlay Form -->
<div class="overlay-detalle" *ngIf="overlayForm">
  <div class="output-detail-form">
    <div class="table-header">
      <h2 class="title">
        <span (click)="toggleOverlayForm(action.None)">
          <app-arrow-back></app-arrow-back>
        </span>
        Toma de muestra
      </h2>
    </div>
    <form
      [formGroup]="samplingForm"
      (ngSubmit)="saveSampling()"
      class="container-grid"
    >

      <!-- Número de oficio -->
      <div>
        <label for="registroMuestraOficio" class="form-label">
          Número de oficio*
        </label>
        <input
          type="text"
          class="form-control"
          id="registroMuestraOficio"
          formControlName="trade_number"
          maxlength="20"
          appBlockLetters
        />
        <span
          class="form-text text-danger"
          *ngIf="isValidField('trade_number')"
        >
          Ingresa el número de oficio válido
        </span>
      </div>

      <!-- Fecha -->
      <div>
        <label for="registroMuestraFecha" class="form-label">
          Fecha*
        </label>
        <input
          type="datetime-local"
          id="registroMuestraFecha"
          class="form-control"
          formControlName="sampling_date"
        />
        <span
          class="form-text text-danger"
          *ngIf="
            samplingForm.get('sampling_date')!.touched &&
            samplingForm.get('sampling_date')?.hasError('required')
          "
        >
          Ingresa la fecha
        </span>
        <span
          class="form-text text-danger"
          *ngIf="
            samplingForm.get('sampling_date')?.hasError('errorDate') &&
            samplingForm.get('sampling_date')!.touched &&
            !samplingForm.get('sampling_date')?.hasError('required')
          "
        >
          La fecha debe ser posterior a la fecha de atraque ({{ blDetails.docking_date }})
        </span>
      </div>

      <!-- Peso de la toma de muestra -->
      <div>
        <label for="registroMuestraPeso" class="form-label">
          Peso de la toma de muestra*
        </label>
        <input
          type="text"
          class="form-control"
          id="registroMuestraPeso"
          formControlName="sample_weight"
          maxlength="15"
          appBlockLetters
        />
        <span
          class="form-text text-danger"
          *ngIf="isValidField('sample_weight')"
        >
          Ingresa el peso válido
        </span>
      </div>

      <div class="grid-all container-button">
        <button type="button" class="btn-lote" (click)="toggleOverlayForm(action.None)">
          Regresar
        </button>
        <button type="submit" class="btn-lote ms-5" *ngIf="canSave">Guardar</button>
      </div>

    </form>
  </div>
</div>

<!-- Overlay message -->
<app-overlay
  *ngIf="overlayMessage"
  [mensaje]="message"
  [icono]="icon"
  [buttons]="buttons"
  (onDeleteLote)="deleteSampling($event)"
></app-overlay>
